import { BrandLogo } from './brand-logo';
import { APP_VERSION } from './version';

export function DownloadsPage(props: { readonly onBack: () => void }) {
  return (
    <main className="downloads-page" dir="rtl">
      <section className="downloads-hero">
        <BrandLogo />
        <div>
          <span>مرکز نصب قالیشور</span>
          <h1>قالیشور را همیشه همراه داشته باشید</h1>
          <p>نسخه مناسب خودتان را نصب کنید؛ کاربران آیفون نیز می‌توانند قالیشور را مثل یک اپ روی صفحه اصلی داشته باشند.</p>
        </div>
      </section>

      <section className="download-grid" aria-label="دانلود برنامه‌های قالیشور">
        <article className="download-card download-card-customer">
          <span className="download-badge">برای مشتریان</span>
          <h2>اپ مشتری قالیشور</h2>
          <p>ثبت درخواست شستشو، دریافت پیشنهاد، انتخاب قالیشویی و پیگیری کامل سفارش.</p>
          <a className="download-primary" href={`/downloads/ghalishor-customer-${APP_VERSION}.apk`} download>دانلود مستقیم برای Android</a>
          <a className="download-secondary" href="/downloads/ghalishor-customer-latest.apk" download>لینک پایدار آخرین نسخه</a>
          <small>نسخه {APP_VERSION} · مناسب Android 7 و بالاتر</small>
        </article>

        <article className="download-card download-card-business">
          <span className="download-badge">برای قالیشویی‌ها</span>
          <h2>اپ همکار قالیشور</h2>
          <p>اعلام آمادگی همکاری، دریافت درخواست‌ها و مدیریت عملیات پس از تأیید مدیران پلتفرم.</p>
          <a className="download-primary" href={`/downloads/ghalishor-business-${APP_VERSION}.apk`} download>دانلود مستقیم برای Android</a>
          <small>نسخه {APP_VERSION} · ثبت درخواست همکاری و فعال‌سازی پس از بررسی مدیران</small>
        </article>
      </section>

      <section className="ios-install-guide">
        <header>
          <span className="download-badge">iPhone و iPad</span>
          <h2>نصب وب‌اپ قالیشور در iOS</h2>
          <p>بدون App Store و در کمتر از یک دقیقه:</p>
        </header>
        <ol>
          <li><strong>۱</strong><span>این صفحه را با مرورگر <b>Safari</b> باز کنید.</span></li>
          <li><strong>۲</strong><span>دکمه اشتراک‌گذاری <b>Share</b> در پایین Safari را بزنید.</span></li>
          <li><strong>۳</strong><span>گزینه <b>Add to Home Screen</b> یا «افزودن به صفحه اصلی» را انتخاب کنید.</span></li>
          <li><strong>۴</strong><span>بالای صفحه روی <b>Add</b> بزنید؛ آیکن قالیشور مثل یک اپ روی گوشی قرار می‌گیرد.</span></li>
        </ol>
        <a className="download-primary ios-open-app" href="/login/customer">باز کردن وب‌اپ مشتری</a>
      </section>

      <button type="button" className="secondary downloads-back" onClick={props.onBack}>بازگشت به صفحه اصلی</button>
    </main>
  );
}
